import { render, staticRenderFns } from "./DocumentsIcon.vue?vue&type=template&id=6bf73a6a&"
import script from "./DocumentsIcon.vue?vue&type=script&lang=js&"
export * from "./DocumentsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports